//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





import UMUM from "../../library/umum";
import DATA_MASTER from "../../library/dataMaster";


export default {
  props: ["biodata_id", "nip"],
  data() {
    
    return {
      // xbiodata_id : this.biodata_id,
      list_riwayat: [],
      list_hukdis_siaAsn: [],


      hukdis : {
        hukdis_id : '',
        pnsOrangId : '',
        golonganId : '',
        biodata_id : this.biodata_id,
        jenisHukumanId : '',
        kedudukanHukumId : '',
        skNomor : '',
        skTanggal : '',
        hukumanTanggal : '',
        masaTahun : '',
        masaBulan : '',
        akhirHukumanTanggal : '',
        nomorPp : '',
        gol_lama : '',
        skPembatalanNomor : '',
        skPembatalanTanggal : '',
        alasanHukumanDisiplinId : '',
        status : 1,
        file : null,
        nip : '',
        uraian: '',
        userId : '',
        createdAt : '',
      },

      dummy : {
        jns_latihan_struktural_id : null,
      },


      mdl_detil_riwayat: false,
      mdl_add: false,

      mdl_detil_riwayat_add_lampiran: false,
      mdl_detil_riwayat_edit: false,
      mdl_detil_riwayat_hapus: false,
      file_old :'',

      UMUM : UMUM,
      DATA_MASTER : DATA_MASTER,

      btn_add: false,


      tab: 'disetujui',


      loadRiwayatSIA : true,
      fileLoadSIA : true,
      fileLoadEmpty : false,
      fileRiwayat : null,
      kodeDok : '882',


      status :1,



    };
  },

  methods: {
    getRiwayat: function(){

      this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_riwayat_hukdis+'view', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              biodata_id : this.hukdis.biodata_id,
              status : this.status
            })
        }).then((res) => res.json()).then((res_data) => {
          this.list_hukdis_siaAsn = res_data;
          this.loadRiwayatSIA = false;
          // console.log(res_data);
        })
    },

    addData : function(number) {

      var formData = new FormData();
      formData.append('hukdis_id', this.hukdis.hukdis_id);
      formData.append('jenisHukumanId', this.hukdis.jenisHukumanId);
      formData.append('alasanHukumanDisiplinId', this.hukdis.alasanHukumanDisiplinId);
      formData.append('kedudukanHukumId', this.hukdis.kedudukanHukumId);
      formData.append('skNomor', this.hukdis.skNomor);
      formData.append('skTanggal', this.hukdis.skTanggal);
      formData.append('hukumanTanggal', this.hukdis.hukumanTanggal);
      formData.append('masaTahun', this.hukdis.masaTahun);
      formData.append('masaBulan', this.hukdis.masaBulan);
      formData.append('akhirHukumanTanggal', this.hukdis.akhirHukumanTanggal);
      formData.append('nomorPp', this.hukdis.nomorPp);
      formData.append('pnsOrangId', this.hukdis.pnsOrangId);
      formData.append('skPembatalanNomor', this.hukdis.skPembatalanNomor);
      formData.append('skPembatalanTanggal', this.hukdis.skPembatalanTanggal);
      formData.append('keterangan', this.hukdis.keterangan);
      formData.append('biodata_id', this.hukdis.biodata_id);
      formData.append('nip', this.nip);

      formData.append('file', this.hukdis.file);

      fetch(this.$store.state.url.URL_simpeg_riwayat_hukdis+'createData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then(res => res.json()).then((data_urusan) => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.getRiwayat();
      });
     
    },


    editData : function(){

      var formData = new FormData();
      formData.append('hukdis_id', this.hukdis.hukdis_id);
      formData.append('jenisHukumanId', this.hukdis.jenisHukumanId);
      formData.append('alasanHukumanDisiplinId', this.hukdis.alasanHukumanDisiplinId);
      formData.append('kedudukanHukumId', this.hukdis.kedudukanHukumId);
      formData.append('skNomor', this.hukdis.skNomor);
      formData.append('skTanggal', this.hukdis.skTanggal);
      formData.append('hukumanTanggal', this.hukdis.hukumanTanggal);
      formData.append('masaTahun', this.hukdis.masaTahun);
      formData.append('masaBulan', this.hukdis.masaBulan);
      formData.append('akhirHukumanTanggal', this.hukdis.akhirHukumanTanggal);
      formData.append('nomorPp', this.hukdis.nomorPp);
      formData.append('skPembatalanNomor', this.hukdis.skPembatalanNomor);
      formData.append('skPembatalanTanggal', this.hukdis.skPembatalanTanggal);
      formData.append('keterangan', this.hukdis.keterangan);
      formData.append('biodata_id', this.hukdis.biodata_id);
      formData.append('nip', this.nip);
      formData.append('file', this.hukdis.file);
      formData.append('file_old', this.file_old);

      fetch(this.$store.state.url.URL_simpeg_riwayat_hukdis+'updateData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then((res_data) => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getRiwayat();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_simpeg_riwayat_hukdis + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.hukdis.hukdis_id, file : this.file_old})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getRiwayat();
      });

    },

    selectRiwayat: function(data){
      this.hukdis.hukdis_id = data.hukdis_id;
      this.hukdis.pnsOrangId = data.pnsOrangId;
      this.hukdis.golonganId = data.golonganId;
      this.hukdis.biodata_id = data.biodata_id;
      this.hukdis.jenisHukumanId = data.jenisHukumanId;
      this.hukdis.alasanHukumanDisiplinId = data.alasanHukumanDisiplinId;
      this.hukdis.kedudukanHukumId = data.kedudukanHukumId;
      this.hukdis.skNomor = data.skNomor;
      this.hukdis.skTanggal = data.skTanggal;
      this.hukdis.hukumanTanggal = data.hukumanTanggal;
      this.hukdis.masaTahun = data.masaTahun;
      this.hukdis.masaBulan = data.masaBulan;
      this.hukdis.akhirHukumanTanggal = data.akhirHukumanTanggal;
      this.hukdis.nomorPp = data.nomorPp;
      this.hukdis.skPembatalanNomor = data.skPembatalanNomor;
      this.hukdis.skPembatalanTanggal = data.skPembatalanTanggal;
      this.hukdis.alasanHukumanDisiplinId = data.alasanHukumanDisiplinId;
      this.hukdis.keterangan = data.keterangan;
      this.hukdis.status = data.status;
      this.hukdis.nip = data.nip;

      if (data.status != 1) {
        this.fileLoadSIA = false
        this.file_old = data.path[this.kodeDok].realname;
      }

      



      console.log(data);

    },


    // assu : function(){
    //   console.log("aaaassssuuuu");
    // },



    // ====================================== INTEGRASI SI-ASN ====================================


    syncDataRiwayatSiASN: function(){

        this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_riwayat_hukdis + "si_asn_viewOne", {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              nip : this.nip,
              biodata_id : this.biodata_id,
              kode : this.kodeDok,
            })
        }).then((res) => res.json()).then((res_data) => {
          this.Notify('Sukses Sync Data', 'warning', 'check_circle_outline');


          this.getRiwayat();

          this.loadRiwayatSIA = false;
          console.log(res_data);
        })
    },

    approveUsulanDataRiwayatSiASN : async function(){

      this.hukdis.nip = this.nip
      this.hukdis.kode = this.kodeDok
      this.hukdis.file_old = this.file_old

      var sex = await UMUM.alertConfirm("Integrasikan ke BKN?")

      if (sex.isConfirmed) {

        fetch(this.$store.state.url.URL_simpeg_riwayat_hukdis + "approve", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.hukdis)
        }).then(res_data => {
            this.Notify('Sukses approve Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },


    getDownloadSIASN: async function(file,kode) {

              
      if (file.path == null || file.path == undefined) {
        this.fileLoadEmpty = true
        console.log("FILE KOSONG");
      } else {
        this.fileLoadEmpty = false


        console.log(file);
        
        var fileGet = file.path[kode].dok_uri
        this.fileLoadSIA = true
        fetch(this.$store.state.url.URL_simpeg_home + "lampiran", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                fileURL: fileGet,
                id : file.hukdis_id,
                kode : this.kodeDok,
            })
            })
            .then(response => response.text())
            .then(res_data => {


                console.log("INI DIA");
                console.log(res_data)
                console.log("INI DIA");
                console.log(typeof(res_data));

                this.fileRiwayat = res_data
                this.fileLoadSIA = false

              

        });




      }


    },



    // ====================================== INTEGRASI SI-ASN ====================================



    alertku: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500  
        });
    },

    Notify: function(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500
      });
    },

  },


  mounted () {
    this.getRiwayat()
    DATA_MASTER.getJnsHukuman();
    DATA_MASTER.getAlasanHukuman();
    DATA_MASTER.getJnsKedudukanHukum();
    // DATA_MASTER.getLatStruktural();
    // DATA_MASTER.getJnsKompetensi();
  },



};
